module.exports = __webpack_public_path__ + "static/media/beikostberatung.186e1b93.jpg";